import {duplicateEmailTemplate} from '@api/api';
import { Editor } from 'grapesjs';
import html2canvas from 'html2canvas';

export default async function duplicate(
	title: string,
	editor: Editor,
	newTitle: string,
  previewCallback: (arg0: string) => void,
  visibleCallback: (arg0: boolean) => void,
) {
	const canvas = editor.Canvas.getBody(); // Get the body of the canvas
	console.log('canvas', canvas);

	const getTemplate = () => {
		const html = editor.getHtml(); // Get HTML from editor
		const css = editor.getCss(); // Get CSS from editor
		const head = editor.getComponents(); // Get head from editor
		const js = editor.getJs(); // Get JS from editor

		console.log(js, head, 'js and head');

		// Combine HTML and CSS into a single template
		const template = `<!DOCTYPE html>
      <html>
        <head>
          <style>${css}</style>
        </head>
        <body>${html}</body>
      </html>`;
		return template;
	};

	// Clone the canvas and apply crossOrigin attribute to images in the clone
	const cloneCanvasWithCORS = async (canvas) => {
		const clone = canvas.cloneNode(true);
		return clone;
	};

	// Generate the snapshot from the cloned canvas
	const snap = async () => {
		// const dataUrl = await domtoimage.toPng(canvas, { width: 800, height: 600 });
		const template = getTemplate();
		setPreview(template);
		visibleCallback(true);
		const altImage = html2canvas(canvas, {
			useCORS: true,
		});
		const altRender = await altImage.then((canvas) => {
			return canvas.toDataURL('image/png');
		});
		return altRender;
	};

	try {
		const snapShot = await snap();
		const payload = {
			title: title,
			content: getTemplate(),
			snapShot: snapShot,
		};
		console.log('payload', payload);
		visibleCallback(false);
		await duplicateEmailTemplate(payload); // Assuming apis.updateEmailTemplate is defined somewhere in your context
	} catch (error) {
		console.error('Error in save callback:', error);
	}
}
